import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const StandardModal = ({ handleChoice }) => {
  const [show, setShow] = useState(true);


  const handleOption = (option) => {
    handleChoice(option);
    setShow(false);
  };

  return (
    <>
      <Modal centered show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Have you mailed your disputes yet?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant='danger' onClick={() => handleOption(0)}>
            No
          </Button>
          <Button variant='primary' onClick={() => handleOption(1)}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StandardModal;
